'use client';
import { useRef } from 'react';
/**
 * Shared decide-card busy/error machinery (deep-code-analysis §3). Owns the
 * `submittedRef` guard and the `applyDecideError` skeleton that every decide
 * card repeated verbatim: reset the guard, normalize the error, then run the
 * card's own `resolveError`. Per-card error copy is injected via `errorCopy`.
 */
export function useDecideAction({ errorCopy, resolveError }) {
    const submittedRef = useRef(false);
    const applyDecideError = (err) => {
        submittedRef.current = false;
        const e = (err ?? {});
        resolveError(e, errorCopy(e.code));
    };
    return { submittedRef, applyDecideError };
}
//# sourceMappingURL=use-decide-action.js.map